import { useMemo, useState } from "react";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useApi } from "@/lib/api";

export function SlaBadge({ t }) {
  if (!t.dueDate || ["RESOLVED", "CLOSED"].includes(t.status)) return null;
  const days = Math.ceil((new Date(t.dueDate) - new Date()) / 864e5);
  const [txt, cls] = days < 0 ? ["Overdue", "bg-rose-600 text-white"] : days === 0 ? ["Due Today", "bg-amber-500 text-white"]
    : [`${days} day${days > 1 ? "s" : ""} remaining`, "bg-secondary text-foreground"];
  return <span className={`text-[10px] font-semibold rounded px-1.5 py-0.5 ${cls}`} data-testid={`sla-badge-${t.ticketNumber}`}>{txt}</span>;
}

export function TicketCustomerPicker({ customers, projects, onPick, onNew }) {
  const { data: leads } = useApi("/leads");
  const [q, setQ] = useState("");
  const rows = useMemo(() => {
    if (q.trim().length < 2) return [];
    const all = [...(customers || []).map((c) => ({ key: `c-${c.id}`, tag: "Customer", name: c.name, phone: c.phone, email: c.email, customerId: c.id })),
      ...(projects || []).map((p) => ({ key: `p-${p.id}`, tag: p.projectCode, name: p.customerName, phone: p.customerPhone, email: p.customerEmail, projectId: p.id })),
      ...(leads || []).map((l) => ({ key: `l-${l.id}`, tag: l.leadNumber, name: l.clientName, phone: l.clientPhone, email: l.clientEmail }))];
    return all.filter((r) => `${r.name} ${r.phone} ${r.tag}`.toLowerCase().includes(q.toLowerCase())).slice(0, 8);
  }, [q, customers, projects, leads]);
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Input placeholder="Search existing customer, lead or project" value={q} onChange={(e) => setQ(e.target.value)} data-testid="ticket-customer-search" />
        <Button type="button" variant="outline" onClick={() => { setQ(""); onNew(); }} data-testid="ticket-add-new-customer"><UserPlus className="h-4 w-4 mr-1.5" />Add New Customer</Button>
      </div>
      {rows.length > 0 && <div className="rounded-md border divide-y max-h-48 overflow-y-auto" data-testid="ticket-customer-results">
        {rows.map((r) => <button type="button" key={r.key} onClick={() => { onPick(r); setQ(""); }} className="w-full text-left px-3 py-2 text-sm hover:bg-secondary/50 transition-colors duration-75" data-testid={`ticket-pick-${r.key}`}>
          <span className="font-medium">{r.name}</span> <span className="text-xs text-muted-foreground">· {r.phone} · {r.tag}</span></button>)}
      </div>}
    </div>
  );
}
